import React, { Component } from "react";
import Logo from "../assets/images/logos/elan-row.png";
import {Nav, NavLink, Bars, NavMenu, Cross} from "./NavbarElements";
import {withUserContext} from "../components/ModalContext";
import WhiteLogo from '../assets/images/logos/elan-row-white-flat.png';
import {Redirect, useHistory} from 'react-router-dom';


class Header extends Component {
  state = {
    sidebarOpened: false,
  };

  toggleSidebar = () =>
    this.setState({ sidebarOpened: !this.state.sidebarOpened });
  closeSidebar = () => this.setState({ sidebarOpened: false });

  getPageColor = () => {
    return window.location.pathname.substr(1);
  };

  render() {

    return (
      <div
        id={"navbar"}
        className={`navbar-container ${this.getPageColor()}-page`}
        data-page={`${this.getPageColor()}`}
      >
        {console.log(this.props)}
        <Nav>

          <NavLink onClick={this.closeSidebar} className={"logo-link"} to="/">
            <img src={this.getPageColor() !=='proshows' ? Logo : WhiteLogo} className={"navbar-logo"} alt="logo" />
          </NavLink>
          {this.state.sidebarOpened ? <Cross
              className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}
              //style={{display:`${this.state.sidebarOpened ? 'block' : 'none'}`}}
              onClick={this.toggleSidebar}
          /> : <Bars
              className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}
              //style={{display:`${this.state.sidebarOpened ? 'none' :'block' }`}}
              onClick={this.toggleSidebar}
          />}

          <NavMenu
            className={`nav-menu ${this.state.sidebarOpened ? "active" : ""}`}
          >

            <a className={'external-link'} onClick={()=>{
              this.closeSidebar();
              this.props.setShowSchedule(true);
              if(window.location.pathname === '/'){
                this.props.setRedirect(true);
              }
            }} >
              SCHEDULE
            </a>

            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/events" activeStyle>
              EVENTS
            </NavLink>
            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/competitions" activeStyle>
              COMPETITIONS
            </NavLink>
            <a className={"external-link"} target={'_blank'} href="https://ca.elan.org.in/">
              CA PORTAL
            </a>
            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/team" activeStyle>
              TEAM
            </NavLink>
            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/social-cause" activeStyle>
              SOCIAL CAUSE
            </NavLink>
            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/sponsors" activeStyle>
              SPONSORS
            </NavLink>
            <NavLink className={'header-navlink'} onClick={this.closeSidebar} to="/contact" activeStyle>
              CONTACT US
            </NavLink>
            <a className={'external-link'} onClick={()=>{
              this.closeSidebar();
              this.props.setShow(true);
            }} style={{display:this.state.sidebarOpened ? 'block' :'none',background:'transparent'}} >
              REGISTER
            </a>

            <a className={'external-link'} href={"https://drive.google.com/file/d/12bEcNHHRXseIuGKPDWVm5WEioimzSc5Q/view?usp=sharing"}
               onClick={this.closeSidebar} style={{display:this.state.sidebarOpened ? 'block' :'none'}} >
              FAQs
            </a>
            {/* Second Nav */}
            {/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */}
          </NavMenu>
          {/*<NavBtn>*/}
          {/*    <NavBtnLink to='/signin'>Sign In</NavBtnLink>*/}
          {/*</NavBtn>*/}
        </Nav>
      </div>
    );
  }
}

export default withUserContext(Header);

// <Grid columns={1}>
//
//     <Grid.Column only={'computer'}>
//         <Menu fluid={true} secondary style={{zIndex:'1', fontWeight:'200',fontSize:'22px', position:'fixed',fontFamily: '\'Paytone One\', sans-serif'}}>
//             <Menu.Item style={{width:'20%'}}>
//                 <Image  src={Logo}  />
//             </Menu.Item>
//             <Menu.Menu  className="navbar-fixed" fluid={true} position="right">
//                 <Menu.Item
//
//                     active={false}
//                 >
//                     EVENTS
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >
//                     COMPETITIONS
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >CAMPUS AMBASSADOR
//
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >TEAM
//
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >SOCIAL CAUSE
//
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >SPONSORS
//
//                 </Menu.Item>
//
//                 <Menu.Item
//
//                     active={false}
//                 >CONTACT US
//                 </Menu.Item>
//             </Menu.Menu>
//
//
//
//
//         </Menu>
//     </Grid.Column>
//     <Grid.Column style={{zIndex:'1'}} only='mobile tablet'>
//         <Menu fluid={true} secondary style={{fontWeight:'200',fontSize:'22px', position:'fixed',fontFamily: '\'Paytone One\', sans-serif'}}>
//             <Menu.Item style={{width:'20%'}}>
//                 <Image  src={Logo}  />
//             </Menu.Item>
//             <Sidebar.Pushable>
//                 <Sidebar
//                     as={Menu}
//                     animation={'overlay'}
//                     onHide={this.handleSidebarHide}
//                     visible={this.state.sidebarOpened}
//                     vertical
//                 >
//                     <Menu.Item
//
//                         active={false}
//                     >
//                         EVENTS
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >
//                         COMPETITIONS
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >CAMPUS AMBASSADOR
//
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >TEAM
//
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >SOCIAL CAUSE
//
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >SPONSORS
//
//                     </Menu.Item>
//
//                     <Menu.Item
//
//                         active={false}
//                     >CONTACT US
//                     </Menu.Item>
//                 </Sidebar>
//
//                 <Sidebar.Pusher dimmed={this.state.sidebarOpened}>
//                     <Segment
//
//                         textAlign='center'
//                         style={{ height:'100vh', padding: '1em 0em'}}
//                         vertical
//                     >
//                         <Container>
//                             <Menu.Menu fixed inverted pointing secondary size='large'>
//
//                                 <Menu.Item onClick={this.handleSidebarShow} fluid={true} position='right'>
//                                     <Icon name='sidebar' />
//                                 </Menu.Item>
//                             </Menu.Menu>
//                         </Container>
//
//                     </Segment>
//                 </Sidebar.Pusher>
//
//             </Sidebar.Pushable>
//
//         </Menu>
//     </Grid.Column>
// </Grid>
